module.exports = __webpack_public_path__ + "static/media/pathwayCareLogo.ad9f24ec.png";